import React from 'react';
import {useSelector} from "react-redux";
import {renderCellExpand} from "../tables/DataGridRenderCellExpand";
import Tooltip from "@material-ui/core/Tooltip";
import BBIconEmptyBox from "../../../assets/bbCustomIcons/BBIconEmptyBox";
import ExpandCloudIntegrationStorageFiles from "./ExpandCloudIntegrationStorageFiles";
import BBDataTable from "../tables/BBDataTable";
import BBIconExclamationTriangleError from "../../../assets/bbCustomIcons/BBIconExclamationTriangleError";
import {BRCustomizedTooltip} from "../accents/BRCustomizedTooltip";

const CloudIntegrationDataDatabasesChart = ({integrationId = null,})=>{
    const {entityInView, portfolios, cloudIntegrations, loadingCloudIntegrations, loadingCloudIntegrationsError, loadingCloudIntegrationData, loadingCloudIntegrationDataError} = useSelector(({breachrisk}) => breachrisk);

    const cloudOptions = cloudIntegrations && cloudIntegrations[entityInView] && cloudIntegrations[entityInView].options;
    const cloudIntegrationObjects = cloudIntegrations && cloudIntegrations[entityInView] && cloudIntegrations[entityInView].integrations;
    const cloudIntegrationData = cloudIntegrations && cloudIntegrations[entityInView] && cloudIntegrations[entityInView].integrations && cloudIntegrations[entityInView].integrationData;

    const singleIntegrationView = !!integrationId;

    const queryData = cloudIntegrationData
    && cloudIntegrationData["databases"]
    &&!singleIntegrationView
        ? cloudIntegrationData["databases"]
        :cloudIntegrationData
        && cloudIntegrationData["databases"]
        && singleIntegrationView
            ? cloudIntegrationData["databases"].filter((object)=>object.integrationId === integrationId)
            : [];

    const hasError = loadingCloudIntegrationDataError && loadingCloudIntegrationDataError[entityInView] && loadingCloudIntegrationDataError[entityInView].databases

    const title = <>
        Databases&nbsp; {hasError
            ? <BRCustomizedTooltip title={loadingCloudIntegrationDataError
            && loadingCloudIntegrationDataError[entityInView]
            && loadingCloudIntegrationDataError[entityInView].databases_error
                ? loadingCloudIntegrationDataError[entityInView].databases_error
                : "An Error Occurred"}>
                <span><BBIconExclamationTriangleError className={'text-bb-risk-high'}/></span>
            </BRCustomizedTooltip>
            : null}
    </>

    const columns = [
        { field: 'id', headerName: ' ID', hide: true, flex : .5, sortable: true, type: 'string', renderCell: (params) => {

                return params.value}},
        { field: 'resourceLogo', headerName: ' ', hide: false, sortable: true, type: 'string', flex : .2, renderCell: (params) =>
                renderCellExpand(params, (<span title={"Provider Logo"}>
                              {params.value ?
                                  <img style={{height: 30, maxWidth:80}} className={"rounded bg-white p-0 m-1 mr-2"} src={params.row.resourceLogo } alt={"Provider Logo"}/>
                                  : <Tooltip title={`Logo for could not be found.`}><span><BBIconEmptyBox className={"rounded bg-white p-0 m-1 mr-2"} style={{fontSize: "20px"}}/></span></Tooltip>
                              }
                          </span>
                ))},
        { field: 'name', headerName: 'Name', hide: false, sortable: true, type: 'string', flex : .75, renderCell: (params) =>
                renderCellExpand(params, (<span>
                                <p>{params.value ? params.value : " "}</p>
                          </span>
                ))},
        { field: 'integrationDescription', headerName: 'Integration', hide: singleIntegrationView, sortable: true, type: 'string', flex : .75, renderCell: (params) =>
                renderCellExpand(params, (<span>
                                <p>{params.value ? params.value : " "}</p>
                          </span>
                ))},
        { field: 'url', headerName: 'URL', hide: false, sortable: true, type: 'string', flex : 1.25, renderCell: (params) =>
                renderCellExpand(params, (<span>
                        <p>{params.value ? params.value : " "}</p>
                          </span>
                ))},
        { field: 'type', headerName: 'Type', hide: false, sortable: true, type: 'string', flex : .4, renderCell: (params) =>
                renderCellExpand(params, (<span>
                        <p>{params.value ? params.value : " "}</p>
                          </span>
                ))},
        { field: 'port', headerName: 'Port', hide: false, sortable: true, type: 'string', flex : .4, renderCell: (params) =>
                renderCellExpand(params, (<span>
                        <p>{params.value ? params.value : " "}</p>
                          </span>
                ))},
    ]

    const tableData = queryData && Array.isArray(queryData) ? queryData.map((entry, index)=>{
        return({
            ...entry,
            id: entry && entry.id ? entry.id : `$__${index}__databases`,
            resourceName: entry && entry.resource && entry.resource.name ? entry.resource.name : null,
            resourceDescription: entry && entry.resource && entry.resource.description ? entry.resource.description : null,
            resourceLogo: entry && entry.resource && entry.resource.logo ? entry.resource.logo : null,
        })
    }) : null

    console.log("CloudIntegration state", cloudIntegrations, "CloudIntegrationData", cloudIntegrationData, "queryData for databases", queryData, "tableData", tableData, "is singleIntegrationView", singleIntegrationView);

    return(
        <div>
            {(loadingCloudIntegrationData
                && loadingCloudIntegrationData[entityInView]
                && !loadingCloudIntegrationData[entityInView]["databases"])
            || (cloudIntegrationObjects && Object.keys(cloudIntegrationObjects).length ===0 )
                ? <BBDataTable
                    title={title}
                    rows={tableData}
                    columns={columns}
                    progressValue={100}
                    disableColumnSelector={true}
                    disableDensitySelector={true}
                    disableColumnMenu={true}
                />
                : <BBDataTable
                    title={title}
                    columns={columns}
                    rows={[]}
                    progressValue={0}
                    disableColumnSelector={true}
                    disableDensitySelector={true}
                    disableColumnMenu={true}
                />}
        </div>
    )
}

export default CloudIntegrationDataDatabasesChart;